import React from "react";
import "./LoadingFallback.scss";

/**
 * LoadingFallback component displayed while lazy-loaded routes are being fetched.
 * Provides a smooth loading experience with a minimal spinner.
 */
const LoadingFallback: React.FC = () => {
  return (
    <div className="loading-fallback" data-testid="loading-fallback">
      <div className="loading-fallback__spinner" />
    </div>
  );
};

export default LoadingFallback;
